import React from 'react'
import { styled } from 'styled-components'
import Frame from '../frames/BasicFrame'
import { cssPlayerHeightUnit } from '../../utility/constants'

import {
	useIsJuniorPlus,
	useMissionStateSelector,
	isTraining,
	useMissionCode,
	useDomainForControls,
} from '../../context'

import { JrStudentView, TeamView } from './StudentViews'

export default function LoginView(): React$Node {
	const isJrPlus = useIsJuniorPlus()
	const isTrainingMode = useMissionStateSelector(isTraining)
	const missionCode = useMissionCode()
	const domainForControls = useDomainForControls()

	return (
		<Frame className="flex flex-col !p-0">
			<Header className="p-4">
				<HeaderItem data-walkthrough="mission-login">
					GO TO {domainForControls}
				</HeaderItem>
				<HeaderItem data-walkthrough="mission-code">
					MISSION CODE: <span>{missionCode}</span>
				</HeaderItem>
			</Header>
			{isTrainingMode && (
				<HeaderItem buffer small>
					TRAINING MODE ACTIVE
				</HeaderItem>
			)}

			<Wrapper className={isJrPlus ? 'p-4 pt-0' : ''}>
				{isJrPlus ? <TeamView /> : <JrStudentView />}
			</Wrapper>
		</Frame>
	)
}

const Header = styled.div`
	column-count: 2;
	column-gap: max(3em, ${cssPlayerHeightUnit(3)});
	width: 100%;
`

const HeaderItem = styled.div`
	background-color: rgba(18, 9, 82, 0.33);
	span {
		text-transform: uppercase;
	}
	font-size: max(5em, ${cssPlayerHeightUnit(5)});
	color: white;
	padding: 25px;
	text-align: center;
	width: 100%;
	${({ buffer }) => (buffer ? `margin-top: ${cssPlayerHeightUnit(5)};` : '')}
	${({ small }) =>
		small
			? `font-size: max(4em, ${cssPlayerHeightUnit(4)}); padding: 15px;`
			: ''}
`

const Wrapper = styled.div`
	font-weight: 300;
	overflow: hidden;
	position: relative;
	flex: 1;
	display: flex;
	flex-direction: column;

	.login-scrollbar {
		&::-webkit-scrollbar {
			width: 8px;
			height: 8px;
		}

		&::-webkit-scrollbar-thumb {
			background: rgba(255, 255, 255, 0.55);
			border-radius: 100vh;
		}

		&::-webkit-scrollbar-thumb:hover {
			background: rgba(255, 255, 255, 0.33);
		}
	}
`
